import { SucursalProps } from '../../../interfaces/sucursal'

/**
 * @description Propiedades de almacen
 * @deprecated
 */
export interface AlmacenBaseProp {
  codigoAlmacen: string // Codigo almacen
  nombre: string // Nombre de compras Ej. Almacen Principal S10
  ubicacion: string // Ubicación fisica del almacen
  sucursal: SucursalProps // Sucursal al que pertenece el almacen
  state?: string
  usucre?: string
  createdAt?: Date
  usumod?: string
  updatedAt?: Date
}

/**
 * @deprecated
 */
export interface AlmacenProp extends AlmacenBaseProp {}

/**
 * @deprecated
 */
export interface AlmacenInputProps {
  codigoAlmacen: string
  nombre: string
  ubicacion: string
  sucursal: SucursalProps | null
  codigoSucursal: SucursalProps | null
  default?: boolean
  state?: string
}

/**
 * @deprecated
 * Se cambia por AlmacenApiInputProps
 */
export interface AlmacenOutputProps {
  nombre: string
  ubicacion: string
  codigoSucursal: number
  tipo: string
  prioridad: number
  activo: boolean
}

/**
 * @deprecated
 */
export const ALMACEN_INITIAL_VALUES: AlmacenInputProps = {
  codigoAlmacen: '',
  nombre: '',
  ubicacion: '',
  sucursal: null,
  codigoSucursal: null,
}
